// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".market-info-header[data-v-be8b710e]{display:flex;flex-direction:column;padding-bottom:0;grid-gap:.625rem;gap:.625rem}@media(min-width:992px){.market-info-header[data-v-be8b710e]{flex-direction:row;align-items:center;justify-content:space-between}}.market-info-header__title[data-v-be8b710e]{display:flex;flex-grow:1}@media(min-width:992px){.market-info-header__search[data-v-be8b710e]{width:19.4375rem;max-width:100%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
